import { Divider, Form, Spin } from "antd";

import AuthContainer from "../../components/authContainer/authContainer";
import AuthContainerItem from "../../components/authContainer/authContainerItem";

import AuthHeader from "../../components/authentication/authHeader";
import FormButton from "../../components/common/form/formButton";
import FormInputItem, {
    loginFormItems,
} from "../../components/common/form/formInput/formInput";
import FormNavigate from "../../components/common/form/formNavigate";
import ErrorMessage from "./../../components/common/errorMessage/errorMessage";
import useLogin from "./../../hooks/useLogin";
import "./login.css";

const LoginHeader = () => {
    return (
        <AuthHeader title='bienvenido'>
            <Divider plain className='uppercase'>
                gestión de socios
            </Divider>
        </AuthHeader>
    );
};
const Login = () => {
    const { isLoading, error, loginUser } = useLogin();

    const onFinish = (values) => {
        const { cuit, password } = values;
        loginUser(cuit, password);
    };

    return (
        <AuthContainer>
            <AuthContainerItem className='login-header'>
                <LoginHeader />
            </AuthContainerItem>
            <AuthContainerItem className='login-form'>
                <Spin spinning={isLoading}>
                    <Form name='loginForm' onFinish={onFinish}>
                        {loginFormItems.map((item) => (
                            <FormInputItem key={item.name} item={item} />
                        ))}
                        <FormButton>Iniciar Sesión</FormButton>

                        <FormNavigate
                            external
                            url='https://app.copanseguros.com.ar/altasocios'
                            addonBefore='No tenés cuenta?'
                        >
                            Registrate
                        </FormNavigate>
                        <FormNavigate url='/forgotpassword'>
                            Olvidaste la contraseña?
                        </FormNavigate>
                    </Form>
                </Spin>
            </AuthContainerItem>

            {error.error && (
                <ErrorMessage errorName={error.name} type='error' />
            )}
        </AuthContainer>
    );
};

export default Login;
